import * as React from "react"
import { cn } from "@/lib/utils"
import { Card, CardHeader, CardTitle, CardAction, CardContent } from "@/shared/ui/atoms/Card"
import { formatCurrency } from "@/lib/utils/formatCurrency"
import { useCountUp } from "@/lib/utils/useCountUp"

interface SummaryCardProps {
  title: string
  amount: number
  currency?: "HNL" | "USD"
  icon?: React.ReactNode
  valueClassName?: string
  amountsVisible?: boolean
}

export function SummaryCard({
  title,
  amount,
  currency = "HNL",
  icon,
  valueClassName,
  amountsVisible = true,
}: SummaryCardProps) {
  const animatedAmount = useCountUp({ target: amount })

  return (
    <Card className="cartera-summary-card">
      <CardHeader>
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {title}
        </CardTitle>
        {icon ? (
          <CardAction>
            <span className="text-muted-foreground">{icon}</span>
          </CardAction>
        ) : null}
      </CardHeader>
      <CardContent>
        <p className={cn("text-2xl font-bold font-mono tracking-tight", valueClassName)}>
          {amountsVisible ? formatCurrency(animatedAmount, currency) : "••••••"}
        </p>
      </CardContent>
    </Card>
  )
}

export default SummaryCard
